import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faGraduationCap, faBars, faTimes, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { ROUTES } from '../../constants/routes';
import SelectInput from '../forms/SelectInput';
import './MainLayout.css';

const MainLayout = ({ children, currentSemester, onSemesterChange, semesterOptions }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const location = useLocation();
  const navRef = useRef(null);
  const hamburgerRef = useRef(null);

  useEffect(() => {
    if (!isMenuOpen) return;
    const handleClickOutside = (event) => {
      // 如果點擊在 nav 或 hamburger button 內，不關閉 menu
      if (
        (navRef.current && navRef.current.contains(event.target)) ||
        (hamburgerRef.current && hamburgerRef.current.contains(event.target))
      ) {
        return;
      }
      setIsMenuOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Dark Mode Effect
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const handleSemesterChange = (e) => {
    onSemesterChange(e.target.value);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', margin: '0' }}>
      <div className="main-layout-container">
        <div className="main-layout-nav">
          <Link to="/" className="main-layout-title">
            <FontAwesomeIcon icon={faGraduationCap} style={{ marginRight: '5px' }} />北科課程系統
          </Link>
          <div className='main-layout-buttons'>
            <button
              className="main-layout-theme-toggle"
              onClick={toggleTheme}
              title={theme === 'light' ? "切換至深色模式" : "切換至淺色模式"}
            >
              <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} />
            </button>

            <div className="main-layout-semester-select">
              <SelectInput
                label="學期"
                name="semester"
                value={currentSemester}
                onChange={handleSemesterChange}
                options={semesterOptions}
                style={{ width: '100%', marginBottom: '0' }}
              />
            </div>

            <button
              className="main-layout-hamburger"
              onClick={toggleMenu}
              ref={hamburgerRef}
            >
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
            </button>
          </div>

          <nav
            ref={navRef}
            className={`main-layout-nav-links ${isMenuOpen ? 'open' : ''}`}
          >
            {ROUTES.filter(route => !route.hideInNav).map(route => (
              <Link
                key={route.id}
                to={route.path}
                className="main-layout-link"
                onClick={() => setIsMenuOpen(false)}
              >
                {route.name}
              </Link>
            ))}
          </nav>
        </div>

        <div className="main-layout-content" key={location.pathname}>
          {children}
        </div>
      </div>

      <footer className="main-layout-footer">
        <p className="main-layout-footer-title">常用連結</p>
        <div className="main-layout-footer-links">
          <a href="https://nportal.ntut.edu.tw/index.do?thetime=1761978968598" className="main-layout-footer-link" target='_blank' rel='noreferrer'>校園入口網站 <FontAwesomeIcon icon={faExternalLinkAlt} style={{ marginLeft: '6px', fontSize: '12px' }} /></a>
          <a href="https://www.ntut.edu.tw/" className="main-layout-footer-link" target='_blank' rel='noreferrer'>校園首頁 <FontAwesomeIcon icon={faExternalLinkAlt} style={{ marginLeft: '6px', fontSize: '12px' }} /></a>
          <a href="https://lib.ntut.edu.tw/mp.asp?mp=100" className="main-layout-footer-link" target='_blank' rel='noreferrer'>台北科技大學圖書館 <FontAwesomeIcon icon={faExternalLinkAlt} style={{ marginLeft: '6px', fontSize: '12px' }} /></a>
          <a href="https://oaa.ntut.edu.tw/p/412-1008-15509.php?Lang=zh-tw" className="main-layout-footer-link" target='_blank' rel='noreferrer'>微學程專區 <FontAwesomeIcon icon={faExternalLinkAlt} style={{ marginLeft: '6px', fontSize: '12px' }} /></a>
        </div>
        <p className="main-layout-footer-copyright">北科課程系統 ｜ Copyright © 2025</p>
      </footer>
    </div>
  );
};

export default MainLayout;
